import React from 'react'
import Header from '../../components/Header/index'
import Linkedin from '../../assets/linkedin.png'
import Github from '../../assets/github.png'
import Email from '../../assets/email.png'
import Instagram from '../../assets/instagram.png'
import {List, Title, ListItem} from './style.js'


function Contact(){
    return(
        <div>
            <Header/>

            <Title>Precisa falar comigo? Segue abaixo alguns meios de contato:</Title>

            <List>
                <ListItem>
                    <a href="https://github.com/alicehabitzreuter" target='_blank' className='icon-github'>
                        <img src={Github} alt=""/>
                    </a>
                    Github
                </ListItem>
                <ListItem>
                    <a href="https://www.linkedin.com/in/alice-habitzreuter" target='_blank' className='icon-linkedin'>
                        <img src={Linkedin} alt=""/>
                    </a>
                    Linkedin
                </ListItem>
                <ListItem>
                    <a href="https://www.instagram.com/alicehabitzreuter/?hl=pt-br" target='_blank' className='icon-instagram'>
                        <img src={Instagram} alt=""/>
                    </a>
                    Instagram
                </ListItem>
                <ListItem>
                    <img src={Email} alt=""/>
                    Email: habitzreuter21@gmail.com
                </ListItem>
            </List>
        </div>
    )
}


export default Contact;